var map = {
	"./en.json": "./src/partners/pco/locales/translations/en.json",
	"./es.json": "./src/partners/pco/locales/translations/es.json",
	"./fr.json": "./src/partners/pco/locales/translations/fr.json",
	"./ja.json": "./src/partners/pco/locales/translations/ja.json",
	"./pt.json": "./src/partners/pco/locales/translations/pt.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/partners/pco/locales/translations sync recursive ^\\.\\/.*\\.json$";